import React from 'react';
import Styles from './NewsletterForm.module.less';
import { ActiveCampaignForm } from '../../../components/landingPage/ActiveCampaignForm';

export const NewsletterForm = () => {
    return (
        <div className={Styles.newsletter}>
            <div>
                <img src="/alude-news-logo.png" />
                <div>
                    <h2>Sua imobiliária mais inteligente em 5 minutos</h2>
                    <p>
                        Toda segunda, quarta e sexta um e-mail com informações
                        do mercado imobiliário chegará na sua caixa.
                    </p>
                </div>
            </div>
            <ActiveCampaignForm activeCampaignId={4} />
        </div>
    );
};
